interface Props {
  contractAddress: string
  projectId: string
  editProjectUrl: string
}

const EditProjectButton = ({ contractAddress, projectId, editProjectUrl }: Props) => {
  return (
    <button
      className="gallery-btn text-sm mb-6"
      onClick={() => window.open(`${editProjectUrl}/${contractAddress}/${projectId}`, "_blank")}
    >
      Edit Project
    </button>
  )
}

export default EditProjectButton
